import { Injectable, inject } from '@angular/core'
import { Observable, catchError, of, tap, finalize } from 'rxjs'
import { BaseAsyncService } from '@core/state/base-service'
import { EtatForcesChargesStore } from '@core/state/etat-forces-charges.store'
import { EtatForcesChargesResponseDto } from '@shared/models/dto/api-dtos'

@Injectable({ providedIn: 'root' })
export class EtatForcesChargesService extends BaseAsyncService {
  private readonly store = inject(EtatForcesChargesStore)

  loadEtatForcesCharges(
    dossierSuccessionId: string,
    searchTerm?: string
  ): Observable<EtatForcesChargesResponseDto | null> {
    this.store.setLoading(true)
    this.store.setError(null)

    const endpoint = this.buildEndpoint(dossierSuccessionId, searchTerm)

    return this.get<EtatForcesChargesResponseDto>(endpoint, {
      logErrors: true,
      retry: this.createRetryConfig(2, 800, 1.5)
    }).pipe(
      tap(response => {
        this.store.setEtatForcesCharges(response)
      }),
      catchError(error => {
        console.error('Error loading état des forces et charges', error)
        this.store.setError('Impossible de charger l’état des forces et charges')
        return of(null)
      }),
      finalize(() => this.store.setLoading(false))
    )
  }

  private buildEndpoint(dossierSuccessionId: string, searchTerm?: string): string {
    const query = searchTerm ? `?searchTerm=${encodeURIComponent(searchTerm)}` : ''
    return `/succession-files/${dossierSuccessionId}/etat-forces-charges${query}`
  }
}

